import axios from 'axios'
import React, { useEffect, useRef, useState } from 'react'
import { Button, Form, Table } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import SimpleReactValidator from 'simple-react-validator'
import { fetchFooterLinks } from '../../../../redux/action/stats/footerLinks'
import MainLoading from '../../../../utils/MainLoading'
import DashboardMainTitle from '../../../dashboardTitle/DashboardMainTitle'
import DeleteModal from './Modals/DeleteModal'
import EditModal from './Modals/EditModal'

const FooterLinks = () => {
    const {t} = useTranslation();
    const [btnLoading, setBtnLoading] = useState(false)
    const [forceUpdate, setForceUpdate] = useState(0)
    const [show, setShow] = useState(true);
    const [createLink, setCreateLink] = useState(false)
    const [modal, setModal] = useState({
        delete: false,
        edit: false,
        id: ''
    })
    const [data, setData] = useState({
        title: '',
        url: ''
    })
    const dispatch = useDispatch()
    const footer_links = useSelector(state => state.footer_links)
    const handleClick = () => { setShow(false) }

    const validator = useRef(new SimpleReactValidator({
        messages: {
          required:"پر کردن این فیلد الزامی است"
        },
    }))

    const handleDataChange = (event) => {
        setData({ ...data, [event.target.name]: event.target.value })
    }

    useEffect(() => {
        if(!footer_links.footer_links.length) {
            dispatch(fetchFooterLinks())
        }
    }, [])

    const handleCreateLink = () => {
        setCreateLink(true)
        window.scrollTo(0, 200)
    }

    const handleFormSubmit = (e) => {
        e.preventDefault()
        setBtnLoading(true)
        if (validator.current.allValid()) {
            axios.post('admin/link', data)
            .then(res => {
                setBtnLoading(false)
                setCreateLink(false)
                window.scrollTo(0, 0)
                setData({
                    title: '',
                    url: ''
                })
                toast.dismiss()	
                toast.success(t("toast_successfully_created") , {position: 'bottom-right',className: 'foo-bar'})
                setTimeout(function(){dispatch(fetchFooterLinks())}, 500)
            })
            .catch( err => {
                console.log(err) 
                setBtnLoading(false)
            })
        } else {
            setBtnLoading(false)
            setForceUpdate(1)
            validator.current.showMessages()
            toast.dismiss()
            toast.error(t("toast_please_fill_in_all_fields") , {position: 'bottom-right',className: 'foo-bar'})
        }
    }

    const handleDeleteLink = (id) => {
        setModal({ delete: true, id: id })
        setShow(true)
    }

    const handleEditLink = (id) => {
        setModal({ edit: true, id: id })
        setShow(true)
    }

    const update = () => {
        setShow(false)
        setTimeout(() => {
            dispatch(fetchFooterLinks())
        }, 1000)
    }

    return (
        <div className='mt-5'>
            {footer_links.loading ?
                <MainLoading />
            :
                <>
                    {footer_links.footer_links.length ?
                        <Table bordered responsive>
                            <thead>
                                <tr>
                                    <th>{t("title")}</th>
                                    <th>{t("url")}</th>
                                    <th className='text-center'> {t("delete")} </th>
                                    <th className='text-center'> {t("edit")} </th>
                                </tr>
                            </thead>
                            <tbody>
                                {footer_links.footer_links.map(link => (
                                    <tr key={link.id}>
                                        <td>{link.title}</td>
                                        <td>{link.url}</td>
                                        <td className='text-center'><button className='btn btn-danger btn-sm px-3' onClick={id => handleDeleteLink(link.id) }>{t("delete")}</button></td>
                                        <td className='text-center'><button className='btn btn-warning btn-sm px-3' onClick={(id) => handleEditLink(link.id)}>{t("edit")}</button></td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    :
                        <h6 className='text-center'> {t("No link added yet")} </h6>    
                    }
                    <div className="col-12 create_btn my-5 d-flex justify-content-end">
                        <button className="btn btn-success" onClick={handleCreateLink} disabled={btnLoading ? true : false}> {t("create link")} <i className="fa fa-plus"></i></button>
                    </div>
                </>
            }
            
            {createLink &&
                <div className="form-container">
                    <DashboardMainTitle> {t("dashboard_nav_create_link")} </DashboardMainTitle>
                    <div className="col-md-5">
                        <Form className="mt-5" onSubmit={handleFormSubmit}>
                            <Form.Group className="mb-3" controlId="formTitle">
                                <Form.Label>{t("title")} : </Form.Label>
                                <Form.Control type="text" name="title" value={data.title} onChange={handleDataChange} />
                                <span className='validator_error'>{validator.current.message('title', data.title, 'required')}</span>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formUrl">
                                <Form.Label>{t("url")} : </Form.Label>
                                <Form.Control type="text" name="url" value={data.url} onChange={handleDataChange} />
                                <span className='validator_error'>{validator.current.message('url', data.url, 'required')}</span>
                            </Form.Group>
                            <Button variant="primary" type="submit" className="btn green-btn" disabled={btnLoading ? true : false}>
                                {t("create")} 
                            </Button>
                        </Form>
                    </div>
                </div>
            }
            {modal.delete && <DeleteModal id={modal.id} show={show} handleClick={handleClick} update={update} /> }
            {modal.edit && <EditModal id={modal.id} show={show} handleClick={handleClick} update={update} /> }
        </div>
    )
}

export default FooterLinks
